"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable_1 = require("../../Collections/HashMap/Hashtable");
var XoneCssRule = /** @class */ (function () {
    function XoneCssRule(sSelectorName) {
        this.m_strName = sSelectorName;
        this.m_bundleRules = new Hashtable_1.default();
    }
    XoneCssRule.prototype.getName = function () {
        return this.m_strName;
    };
    /**
     * El método String.intern() nos ahorra bastante memoria aquí.
     * TODO 26/07/2018 Juan Carlos
     * Esto de internar las cadenas es horriblemente lento en algunos teléfonos. Revisar.
     * <p>
     * Tag: Luis 1604201802
     * Corregido un error en los valores de los css, que no pueden tener espacio. Se le hace trim()
     *
     * @param sRuleKey
     * @param sRuleValue
     */
    XoneCssRule.prototype.addRule = function (sRuleKey, sRuleValue) {
        this.m_bundleRules.put(sRuleKey, sRuleValue.trim());
    };
    XoneCssRule.prototype.getRuleValue = function (sRuleKey) {
        if (this.m_bundleRules.containsKey(sRuleKey)) {
            return this.m_bundleRules.get(sRuleKey);
        }
        // No lo conejo
        return null;
    };
    XoneCssRule.prototype.deleteRule = function (sRuleKey) {
        if (this.m_bundleRules.containsKey(sRuleKey)) {
            this.m_bundleRules.delete(sRuleKey);
        }
    };
    XoneCssRule.prototype.contains = function (sRuleKey) {
        return this.m_bundleRules.containsKey(sRuleKey);
    };
    return XoneCssRule;
}());
exports.default = XoneCssRule;

//# sourceMappingURL=XoneCssRule.js.map
